import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { NgIf } from '@angular/common';

/** Grey rounded panel with an optional title — same look as the time-range-picker (e.g. Best Contact Time). */
@Component({
	selector: 'formly-panel-wrapper',
	template: `
		<div class="field-panel">
			<span *ngIf="props.label" class="section-title">{{ props.label }}</span>
			<ng-container #fieldComponent></ng-container>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.field-panel {
				background: rgba(0, 0, 0, 0.03);
				border-radius: 1rem;
				margin: 0 0 1rem 0;
				padding: 0.4rem 0.75rem 0 0.75rem;
			}
			.section-title {
				display: block;
			}
		`,
	],
	imports: [NgIf],
})
export class PanelWrapper extends FieldWrapper {}
